import { DEFAULT_TRIPS_LIST_PAGE } from 'Views/account/queries/account.queries';
export type BookingsState = {
  data: Array<BookingEntity>;
  meta: {
    currentPage: number;
    hasMoreTrips: boolean;
    isLoading: boolean;
  };
};
type BookingAction =
  | {
      type: 'SET_BOOKINGS' | 'NEXT_TRIPS_PAGE_LOADED';
      payload: {
        data: Array<BookingEntity>;
        hasMoreTrips: boolean;
      };
    }
  | {
      type: 'FETCH_NEXT_TRIPS_PAGE';
    };
export const initialBookingsState: BookingsState = {
  data: [],
  meta: {
    isLoading: false,
    currentPage: DEFAULT_TRIPS_LIST_PAGE,
    hasMoreTrips: false,
  },
};
export const bookingsReducer = (state: BookingsState, action: BookingAction): BookingsState => {
  let nextState: BookingsState;

  switch (action.type) {
    case 'SET_BOOKINGS':
      nextState = {
        data: action.payload.data,
        meta: { ...state.meta, hasMoreTrips: action.payload.hasMoreTrips },
      };
      break;

    case 'FETCH_NEXT_TRIPS_PAGE':
      nextState = { ...state, meta: { ...state.meta, isLoading: true } };
      break;

    case 'NEXT_TRIPS_PAGE_LOADED':
      nextState = {
        data: [...state.data, ...action.payload.data],
        meta: {
          isLoading: false,
          currentPage: state.meta.currentPage + 1,
          hasMoreTrips: action.payload.hasMoreTrips,
        },
      };
      break;

    default:
      nextState = state;
  }

  return nextState;
};
export const mapToLoadedAction = ({
  customerBookings,
}: {
  customerBookings: PaginatedBookings;
}): BookingAction => ({
  type: 'NEXT_TRIPS_PAGE_LOADED',
  payload: {
    data: customerBookings?.data || [],
    hasMoreTrips: customerBookings?.pageInfo?.hasNextPage,
  },
});
